<div class="p-3 flex flex-column flex-auto">

    <div class="flex align-items-center justify-content-between mb-3">
        <h3 style="margin-bottom:0;">{{pageTitle}} — Today's Bookings</h3>
        <div>
            <button pButton type="button" class="p-button p-button-sm p-button-outlined"
                    (click)="loadgrid()"
                    pTooltip="Refresh Data"
                    style="margin-right: 10px;">
                <span class="pi pi-refresh"></span>
            </button>
            <button pButton type="button" class="p-button p-button-sm p-button-outlined"
                    (click)="goBack()"
                    pTooltip="Return to At a Glance">
                <span class="pi pi-angle-left" style="margin-right:8px;"></span>
                <span>Return to At a Glance</span>
            </button>
        </div>
    </div>

    <div style="width:100%">
        <div style="float:right; margin-bottom: 20px;">
            <span class="p-input-icon-left ml-auto" style="margin-right:20px;">
                <i class="pi pi-search"></i>
                <input pInputText type="text" (input)="resourceTable.filterGlobal($event.target.value, 'contains')" style="height: 50px;padding-left:33px;" placeholder="Sales ID/Name"/>
            </span>
        </div>
    </div>

    <div *ngIf="!ListBookings || ListBookings.length === 0" style="width:100%">
        <p style="text-align:center; font-size:24px;">There are no bookings in this category for today.</p>
    </div>

    <div class="surface-card p-4 shadow-2 border-round">
        <p-table #resourceTable
            [value]="ListBookings"
            [paginator]="true"
            [rows]="25"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            [rowsPerPageOptions]="[10,25,50]"
            [globalFilterFields]="['name', 'bookingId', 'bookingIdHR', 'packageName', 'resourcestring']"
            responsiveLayout="scroll"
            sortField="startTime" [sortOrder]="1">
            <ng-template pTemplate="header">
                <tr>
                    <th width="1%">&nbsp;</th>
                    <th width="1%">&nbsp;</th>
                    <th pSortableColumn="bookingIdHR" width="8%">Sales ID
                        <p-sortIcon field="bookingIdHR"></p-sortIcon>
                    </th>
                    <th pSortableColumn="startTime" width="10%">Start Date
                        <p-sortIcon field="startTime"></p-sortIcon>
                    </th>
                    <th pSortableColumn="startTime" width="5%">Time
                        <p-sortIcon field="startTime"></p-sortIcon>
                    </th>
                    <th pSortableColumn="name" width="12%">Name
                        <p-sortIcon field="name"></p-sortIcon>
                    </th>
                    <th pSortableColumn="admissions" width="18%">Admissions
                        <p-sortIcon field="admissions"></p-sortIcon>
                    </th>
                    <th pSortableColumn="packageName" width="15%">Package
                        <p-sortIcon field="packageName"></p-sortIcon>
                    </th>
                    <th pSortableColumn="resourcestring" width="10%">Resource
                        <p-sortIcon field="resourcestring"></p-sortIcon>
                    </th>
                    <th pSortableColumn="guests" width="5%">Guests
                        <p-sortIcon field="guests"></p-sortIcon>
                    </th>
                    <th pSortableColumn="total" width="7%">Total
                        <p-sortIcon field="total"></p-sortIcon>
                    </th>
                    <th pSortableColumn="outstanding" width="7%">O/S
                        <p-sortIcon field="outstanding"></p-sortIcon>
                    </th>
                    <th width="10%">Allergy</th>
                    <th width="10%">Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data>
                <tr
                    [ngStyle]="{'background-color': data.checkedin ? '#f0fdf4' : (data.allergy != '' && data.allergy != null) ? '#FFFFB2' : '#ffffff'}"
                    onmouseover="this.originalstyle=this.style.backgroundColor;this.style.backgroundColor='#dddddd'"
                    onmouseout="this.style.backgroundColor=this.originalstyle;"
                    style="cursor:pointer;"
                    (click)="editBooking(data.bookingId)">
                    <td>
                        <span *ngIf="data.publicBooking" class="pi pi-user"></span>
                    </td>
                    <td>
                        <span style="color:red" *ngIf="data.notes != '' && data.notes != null" class="pi pi-exclamation-circle" pTooltip="{{data.notes}}"></span>
                    </td>
                    <td>{{data.bookingIdHR}}</td>
                    <td>{{data.startTime | date:'dd/MM/yy'}}</td>
                    <td>{{data.startTime | date:'HH:mm' : 'UTC'}}</td>
                    <td>{{data.name}} ({{maskMobile(data.phone)}})</td>
                    <td>{{data.admissions}}</td>
                    <td>{{data.packageName}}</td>
                    <td>{{data.resourcestring}}</td>
                    <td>{{data.guests}}</td>
                    <td>{{data.total | currency: (data.currency || CurrencySymbol)}}</td>
                    <td *ngIf="data.outstanding <= 0">{{data.outstanding | currency: (data.currency || CurrencySymbol)}}</td>
                    <td *ngIf="data.outstanding > 0"><span style="color: Red; font-weight: bold;">{{data.outstanding | currency: (data.currency || CurrencySymbol)}}</span></td>
                    <td>{{data.allergy}}</td>
                    <td (click)="$event.stopPropagation()">
                        <button *ngIf="!data.checkedin && data.haswaiver"
                                pButton type="button"
                                class="p-button-sm p-element p-ripple p-button-success p-button p-component"
                                style="width:100px;"
                                (click)="goToManageWaivers(data.bookingId)">
                            <span class="pi pi-sign-in" style="margin-right:6px;"></span>
                            <span>Admit</span>
                        </button>
                        <button *ngIf="!data.checkedin && !data.haswaiver"
                                pButton type="button"
                                class="p-button-sm p-element p-ripple p-button-success p-button p-component"
                                style="width:100px;"
                                (click)="admitall(data.bookingId)">
                            <span class="pi pi-sign-in" style="margin-right:6px;"></span>
                            <span>Admit</span>
                        </button>
                        <button *ngIf="data.checkedin"
                                pButton type="button"
                                class="p-button-sm p-element p-ripple p-button-danger p-button p-component"
                                style="width:100px;"
                                (click)="leaveall(data.bookingId)">
                            <span class="pi pi-sign-out" style="margin-right:6px;"></span>
                            <span>Leave</span>
                        </button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>


<!-- Scanned booking. This page is people on their way out, so it carries the booking and one
     action - no allergy or notes to read, and nothing that leads away from the counter. -->
<p-dialog header="Scanned Booking" [(visible)]="showScanDialog" [modal]="true" [style]="{'width': '520px'}" [closable]="true" (onHide)="closeScanDialog()">
    <div *ngIf="scannedBooking" style="padding: 0.25rem 0;">

        <div *ngIf="!scannedBookingIsAdmitted()" class="cbl-notin">
            <span class="pi pi-info-circle"></span>
            <span>This booking is not currently admitted.</span>
        </div>

        <table style="width:100%; border-collapse: collapse;">
            <tr>
                <td style="font-weight:bold; padding: 8px; width:35%;">Booking Ref</td>
                <td style="padding: 8px;">{{scannedBooking.bookingIdHR}}</td>
            </tr>
            <tr style="background-color:#f5f5f5;">
                <td style="font-weight:bold; padding: 8px;">Name</td>
                <td style="padding: 8px;">{{scannedBooking.name}}</td>
            </tr>
            <tr>
                <td style="font-weight:bold; padding: 8px;">Start Time</td>
                <td style="padding: 8px;">{{scannedBooking.startTime | date:'dd/MM/yyyy HH:mm' : 'UTC'}}</td>
            </tr>
            <tr style="background-color:#f5f5f5;">
                <td style="font-weight:bold; padding: 8px;">Package</td>
                <td style="padding: 8px;">{{scannedBooking.packageName}}</td>
            </tr>
            <tr>
                <td style="font-weight:bold; padding: 8px;">Guests</td>
                <td style="padding: 8px;">{{scannedBooking.guests}}</td>
            </tr>
        </table>
    </div>
    <ng-template pTemplate="footer">
        <button pButton type="button" label="Leave" icon="pi pi-sign-out" class="p-button-danger cbl-scan-btn" [disabled]="!scannedBookingIsAdmitted()" (click)="leaveScannedBooking()"></button>
    </ng-template>
</p-dialog>
